import React, { useEffect } from "react";
import { Table,Space,Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useItemModel } from "../itemModel";
import { IItemDetail } from "../itemType";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";



export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,onDisabled
    } = useItemModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const columns: ColumnsType<IItemDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (text, record, index) => `${index + 1}`
        }, {
            // title: '项目编码',
            title: Locale["Item Code"],
            dataIndex: 'code',
        }, {
            // title: '项目名称',
            title: Locale["Item"],
            dataIndex: 'name',
        }, {
            title: Locale['ItemEn'],
            dataIndex: 'nameEn',  
        }, {
            // title: '工时',
            title: Locale["Man-hours"],
            dataIndex: 'workHours',
        }, {
            // title: '单价',
            title: Locale["Unit Price"],
            dataIndex: 'price',
        }, {
            // title: '工时费',
            title: Locale["Labor Cost"],
            dataIndex: 'amount',        
        }, {
            // title: '备注',
            title: Locale["Note"],
            dataIndex: 'note',     
        }, {
            // title: '操作',
            title: Locale["Operation"],
            width: 120,
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        onDisabled(record.id as string, checked);
                    }} />
                </Space>
            ),           
        }
    ];

    useEffect(() => {
        loadData()
    }, []);

    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id as string]);
        }
    };

    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                type:"radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IItemDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string)
            })}
            scroll={{ x: 'max-content',y:500 }}
        />
    )
}
